import { Skin, EditionVariant } from '#src/__generated__/globalTypes.ts';
import { unitMapping } from '#src/lib/style.ts';
import fullArt from './assets/full_art.webp';
import fullArtVariant from './assets/full_art_variant.webp';
import holo from './assets/holo.webp';
import holoVariant from './assets/holo_variant.webp';
import shiny from './assets/shiny.webp';
import shinyVariant from './assets/shiny_variant.webp';
import standard from './assets/standard.webp';

const SKIN_IMAGES: Record<Skin, string> = {
  [Skin.FULL_ART]: fullArt,
  [Skin.HOLO]: holo,
  [Skin.SHINY]: shiny,
  [Skin.STANDARD]: standard,
};

const SKIN_VARIANT_IMAGES = {
  [Skin.FULL_ART]: fullArtVariant,
  [Skin.HOLO]: holoVariant,
  [Skin.SHINY]: shinyVariant,
} as const;

type Props = {
  skin: Nullable<Skin>;
  size?: keyof typeof unitMapping;
  variant?: EditionVariant;
};

export const SkinIcon = ({ skin, size = 2, variant }: Props) => {
  const width = unitMapping[size];
  if (!skin) {
    return null;
  }
  if (variant && variant !== EditionVariant.BASE && skin !== Skin.STANDARD) {
    return (
      <img
        src={SKIN_VARIANT_IMAGES[skin]}
        alt={skin}
        style={{ width, height: width }}
      />
    );
  }
  return (
    <img src={SKIN_IMAGES[skin]} alt={skin} style={{ width, height: width }} />
  );
};
